import { useContext } from 'react';

import Context from './Context';

function useMetrics() {
  return useContext(Context);
}

export default useMetrics;
